import { render } from "./MoneyCheckEditor.vue?vue&type=template&id=29ba9c4c"
import script from "./MoneyCheckEditor.vue?vue&type=script&lang=ts"
export * from "./MoneyCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script